import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { ApplicationProxyService } from '../shared/services/applicationproxy.service';

@Injectable()
export class OccupationListResolver implements Resolve {
  constructor(appProxy: ApplicationProxyService) {
    this.appProxy = appProxy;
  }

  resolve(route:ActivatedRouteSnapshot, state:RouterStateSnapshot) {
    return new Promise(resolve => {
      this.appProxy.getOccupationList(v => resolve(v));
    });
  }
}
